import React from 'react';
import ReactDOM from 'react-dom';
import Fsgo from "./FsgoComponent";

let renderFsgo = function(id) {
	let mountNode = document.getElementById(id);

	if (mountNode) {
		performance.mark(`fsgo[0]-render-start`);
		let title = mountNode.getAttribute('title');
		let regionalIds = mountNode.getAttribute('regional-ids');
		let postType = mountNode.getAttribute('post-type');
		let videosItemSize = mountNode.getAttribute('videos-item-size');
		let isFifaWC = mountNode.getAttribute('fifa-wc');
		ReactDOM.render(<Fsgo title={title}
							  regionalIds={regionalIds}
							  postType={postType}
							  videosItemSize={videosItemSize}
							  isFifaWC={isFifaWC === '1'}
							  componentId={0}/>, mountNode);
	}
}

let mountNodes = document.getElementsByTagName('Fsgo');

if (mountNodes) {
	for (let i = 0; i < mountNodes.length; i++){
		let mountNode = mountNodes[i];
		renderFsgo(mountNode.getAttribute('id'));
	}
}

window.renderFsgo = renderFsgo;



// WEBPACK FOOTER //
// ./react-app-src/fsgo/components/Fsgo.js